"use strict";

/**
 * У фф есть проблема - у ячейки рассчитывается неверное значение border. Дёргаем класс, чтобы пересчиталось
 * todo По возможности, найти способ получше
 */
$(function(){
    var self = {
        _fixerStyle: [
            "<style>\n",
                ".moz-border-fixer .calendar-cell{\n",
                    "border-width:0 !important;\n",
                "}\n",
            "</style>\n"
        ].join(""),
        _borderFixer: null,
        enqueueBorderFixer: function(){
            if (self._borderFixer){
                clearTimeout(self._borderFixer);
            } else {
                $(document.documentElement).addClass("moz-border-fixer");
            }
            self._borderFixer = setTimeout(function(){
                self._borderFixer = null,
                $(document.documentElement).removeClass("moz-border-fixer");
            }, 0);
        },
    };

    if ($.browser.mozilla){
        $(document).on(Fotobook.events.SETUP_BOOK_CONTAINER, ".calendar-container", self.enqueueBorderFixer);
        $("body").append(self._fixerStyle);
    }
});